"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgramCalendar = exports.ProgramDirection = exports.ProgramType = exports.ProgramStatus = void 0;
var ProgramStatus;
(function (ProgramStatus) {
    ProgramStatus["AWAITING_FORECASTS"] = "AWAITING_FORECASTS";
    ProgramStatus["DRAFT"] = "DRAFT";
    ProgramStatus["PUBLISHED"] = "PUBLISHED";
    ProgramStatus["INACTIVE"] = "INACTIVE";
})(ProgramStatus = exports.ProgramStatus || (exports.ProgramStatus = {}));
var ProgramType;
(function (ProgramType) {
    ProgramType["MONTHLY"] = "MONTHLY";
    ProgramType["QUARTERLY"] = "QUARTERLY";
})(ProgramType = exports.ProgramType || (exports.ProgramType = {}));
var ProgramDirection;
(function (ProgramDirection) {
    ProgramDirection["BUY"] = "BUY";
    ProgramDirection["SELL"] = "SELL";
})(ProgramDirection = exports.ProgramDirection || (exports.ProgramDirection = {}));
var ProgramCalendar;
(function (ProgramCalendar) {
    ProgramCalendar["STANDARD"] = "STANDARD";
    ProgramCalendar["SPECIAL"] = "SPECIAL";
})(ProgramCalendar = exports.ProgramCalendar || (exports.ProgramCalendar = {}));
